import {radialProgressiveBlur} from '@remotion/effects/radial-progressive-blur';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	HtmlInCanvas,
	interpolate,
	Solid,
	useCurrentFrame,
} from 'remotion';

export const CloseUp8Preview = () => {
	const frame = useCurrentFrame();

	return (
		<HtmlInCanvas
			width={1920}
			height={1080}
			effects={[
				radialProgressiveBlur({
					center: [0.445, 0.485],
					width: 2.047,
					height: 1.784,
					endBlur: 15,
					rotation: -16.9,
				}),
			]}
		>
			<Solid
				width={1920}
				height={1080}
				color={'#1f2427'}
				style={{
					position: 'absolute',
				}}
			/>
			<AbsoluteFill
				name="Canvas Capture"
				style={{
					width: 3102,
					height: 3030,
					translate: '484.3px -1933.5px',
					scale: 0.725,
					rotate: '0.997177 -0.007592 -0.074696 53.392063deg',
					transformOrigin: '10.15% 86.1%',
				}}
			>
				<Video
					src="https://remotion.media/studio-close-ups/close-up-8.mp4"
					style={{
						position: 'absolute',
					}}
				/>
				<MacOSCursor
					cursor="auto"
					style={{
						position: 'absolute',
						left: 0,
						top: 0,
						scale: 3,
						translate: interpolate(
							frame,
							[
								11, 47, 48, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 63,
								64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79,
								80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95,
								96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108,
								109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121,
								122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134,
								135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147,
								148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160,
								161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173,
								174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186,
								187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199,
								200, 201, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231,
								232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244,
								245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257,
								258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270,
								271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283,
								284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296,
								297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309,
								310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322,
								323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335,
								336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348,
								349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361,
								362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374,
								375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387,
								388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400,
								401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413,
								414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426,
								438, 439, 440, 441, 442, 444, 445, 446,
							],
							[
								'331.93359375px 2223.33984375px',
								'331.93359375px 2223.33984375px',
								'403.5234375px 2860.65234375px',
								'403.5234375px 2860.65234375px',
								'403.5234375px 2859.7734375px',
								'403.125px 2858.37890625px',
								'399.046875px 2854.6640625px',
								'396.8671875px 2851.8046875px',
								'396.140625px 2849.68359375px',
								'395.84765625px 2847.55078125px',
								'395.84765625px 2846.1796875px',
								'395.84765625px 2844.3046875px',
								'395.84765625px 2840.37890625px',
								'395.34375px 2837.96484375px',
								'394.08984375px 2833.21875px',
								'394.08984375px 2833.21875px',
								'376.265625px 2811.84375px',
								'372.515625px 2804.12109375px',
								'369.52734375px 2797.921875px',
								'367.8984375px 2794.76953125px',
								'365.71875px 2790.09375px',
								'363.90234375px 2784.78515625px',
								'362.96484375px 2777.87109375px',
								'362.4140625px 2771.859375px',
								'361.59375px 2760.48046875px',
								'361.171875px 2742.7734375px',
								'361.171875px 2742.7734375px',
								'360.24609375px 2727.3515625px',
								'359.203125px 2716.23046875px',
								'356.98828125px 2695.3359375px',
								'356.765625px 2693.16796875px',
								'355.640625px 2676.3046875px',
								'355.48828125px 2675.6953125px',
								'354.890625px 2672.68359375px',
								'354.65625px 2668.453125px',
								'354.65625px 2663.15625px',
								'354.65625px 2657.89453125px',
								'354.41015625px 2654.05078125px',
								'354.33984375px 2652.234375px',
								'354px 2649.375px',
								'354px 2646.15234375px',
								'354.09375px 2639.98828125px',
								'354.41015625px 2634.29296875px',
								'354.046875px 2629.3125px',
								'353.56640625px 2626.37109375px',
								'353.28515625px 2624.21484375px',
								'353.1796875px 2622.43359375px',
								'353.1796875px 2620.23046875px',
								'353.1796875px 2617.91015625px',
								'353.1796875px 2613.36328125px',
								'353.1796875px 2608.7578125px',
								'353.1796875px 2605.921875px',
								'353.1796875px 2603.73046875px',
								'352.98046875px 2600.56640625px',
								'352.53515625px 2596.171875px',
								'352.06640625px 2590.546875px',
								'351.9140625px 2583.890625px',
								'351.9140625px 2573.07421875px',
								'351.9140625px 2565.3046875px',
								'351.9140625px 2565.3046875px',
								'346.78125px 2543.40234375px',
								'345.515625px 2536.03125px',
								'344.98828125px 2526.703125px',
								'344.80078125px 2516.80078125px',
								'344.25px 2503.23046875px',
								'343.20703125px 2491.734375px',
								'343.20703125px 2491.734375px',
								'342.83203125px 2485.546875px',
								'342.12890625px 2474.54296875px',
								'340.91015625px 2465.05078125px',
								'339.4921875px 2456.68359375px',
								'338.70703125px 2449.921875px',
								'337.96875px 2442.84375px',
								'337.453125px 2437.58203125px',
								'336.4453125px 2428.1953125px',
								'335.47265625px 2420.28515625px',
								'334.44140625px 2411.02734375px',
								'334.44140625px 2405.203125px',
								'334.44140625px 2399.8828125px',
								'334.1484375px 2396.4609375px',
								'332.98828125px 2390.8828125px',
								'332.09765625px 2385.6328125px',
								'331.62890625px 2379.515625px',
								'331.23046875px 2374.62890625px',
								'331.16015625px 2368.83984375px',
								'331.1015625px 2365.0546875px',
								'330.71484375px 2360.87109375px',
								'330.421875px 2356.3125px',
								'330.421875px 2346.33984375px',
								'330.421875px 2338.91015625px',
								'330.046875px 2330.90625px',
								'329.68359375px 2325.9609375px',
								'329.1796875px 2318.70703125px',
								'328.79296875px 2313.46875px',
								'328.6875px 2308.875px',
								'327.9375px 2304.94921875px',
								'327.140625px 2299.1484375px',
								'326.4609375px 2292.84375px',
								'325.60546875px 2287.30078125px',
								'325.32421875px 2284.1015625px',
								'324.94921875px 2279.07421875px',
								'324.85546875px 2274.421875px',
								'324.83203125px 2267.390625px',
								'324.328125px 2259.609375px',
								'323.9296875px 2254.546875px',
								'323.63671875px 2249.42578125px',
								'323.63671875px 2244.03515625px',
								'323.63671875px 2237.7890625px',
								'323.63671875px 2233.1953125px',
								'323.63671875px 2228.14453125px',
								'323.63671875px 2219.6484375px',
								'323.19140625px 2211.046875px',
								'323.09765625px 2203.21875px',
								'322.51171875px 2191.86328125px',
								'322.0546875px 2184.0234375px',
								'321.28125px 2175.5390625px',
								'319.08984375px 2167.67578125px',
								'316.34765625px 2158.37109375px',
								'315.92578125px 2150.6015625px',
								'315.92578125px 2145.6328125px',
								'315.92578125px 2142.01171875px',
								'315.87890625px 2138.484375px',
								'315.55078125px 2135.70703125px',
								'315.2578125px 2131.125px',
								'315.2578125px 2123.6015625px',
								'315.2578125px 2118.9609375px',
								'315.01171875px 2116.37109375px',
								'314.2734375px 2112.328125px',
								'313.91015625px 2109.890625px',
								'313.44140625px 2104.76953125px',
								'313.44140625px 2102.77734375px',
								'313.44140625px 2100.046875px',
								'313.3359375px 2097.5390625px',
								'313.171875px 2095.51171875px',
								'313.171875px 2092.20703125px',
								'313.171875px 2088.10546875px',
								'313.171875px 2085.65625px',
								'313.171875px 2083.55859375px',
								'313.171875px 2082.140625px',
								'313.171875px 2078.82421875px',
								'313.171875px 2075.47265625px',
								'313.171875px 2071.1484375px',
								'313.06640625px 2068.3125px',
								'312.97265625px 2066.015625px',
								'312.97265625px 2062.55859375px',
								'313.359375px 2057.05078125px',
								'313.41796875px 2054.14453125px',
								'313.41796875px 2051.05078125px',
								'313.41796875px 2050.60546875px',
								'313.32421875px 2049.17578125px',
								'313.078125px 2047.76953125px',
								'313.078125px 2047.41796875px',
								'313.078125px 2047.23046875px',
								'313.078125px 2047.11328125px',
								'313.078125px 2047.11328125px',
								'313.078125px 2047.16015625px',
								'313.078125px 2047.74609375px',
								'313.078125px 2051.1796875px',
								'312.55078125px 2058.64453125px',
								'310.23046875px 2068.1484375px',
								'306.43359375px 2079.83203125px',
								'304.18359375px 2087.28515625px',
								'300.80859375px 2095.98046875px',
								'299.1328125px 2099.87109375px',
								'299.1328125px 2099.87109375px',
								'298.62890625px 2102.1328125px',
								'298.27734375px 2103.71484375px',
								'297.5859375px 2106.09375px',
								'296.9296875px 2108.37890625px',
								'296.00390625px 2111.05078125px',
								'294.8203125px 2114.4609375px',
								'293.96484375px 2117.8359375px',
								'293.16796875px 2119.86328125px',
								'292.46484375px 2122.62890625px',
								'292.18359375px 2124.31640625px',
								'291.84375px 2126.578125px',
								'291.48046875px 2129.203125px',
								'291.05859375px 2132.89453125px',
								'290.68359375px 2136.2109375px',
								'290.5546875px 2140.7578125px',
								'290.34375px 2143.76953125px',
								'289.48828125px 2149.06640625px',
								'289.0078125px 2153.671875px',
								'288.73828125px 2156.12109375px',
								'288.66796875px 2159.75390625px',
								'288.3515625px 2163.6796875px',
								'288.3515625px 2166.80859375px',
								'288.3515625px 2170.1484375px',
								'288.08203125px 2174.49609375px',
								'287.6015625px 2179.74609375px',
								'287.2265625px 2183.765625px',
								'287.16796875px 2188.453125px',
								'287.1328125px 2191.18359375px',
								'286.7109375px 2195.35546875px',
								'286.41796875px 2199.05859375px',
								'286.1953125px 2203.4296875px',
								'285.99609375px 2207.68359375px',
								'285.69140625px 2212.1484375px',
								'285.26953125px 2216.7421875px',
								'284.8125px 2222.15625px',
								'284.33203125px 2227.3828125px',
								'283.5703125px 2232.99609375px',
								'283.5703125px 2237.02734375px',
								'283.5703125px 2241.9375px',
								'283.4296875px 2245.921875px',
								'283.3125px 2249.40234375px',
								'283.0078125px 2254.04296875px',
								'282.5390625px 2259.796875px',
								'282.03515625px 2266.74609375px',
								'281.5078125px 2275.171875px',
								'281.015625px 2285.51953125px',
								'281.015625px 2291.00390625px',
								'280.93359375px 2295.41015625px',
								'280.81640625px 2298.8671875px',
								'280.81640625px 2304.12890625px',
								'280.55859375px 2308.91015625px',
								'279.78515625px 2314.27734375px',
								'279.6328125px 2318.47265625px',
								'279.22265625px 2323.78125px',
								'279.1640625px 2326.44140625px',
								'278.87109375px 2329.30078125px',
								'278.87109375px 2331.1875px',
								'278.87109375px 2333.4609375px',
								'278.87109375px 2336.109375px',
								'278.6015625px 2339.953125px',
								'278.44921875px 2342.40234375px',
								'278.44921875px 2345.35546875px',
								'278.44921875px 2347.125px',
								'278.44921875px 2350.8515625px',
								'278.30859375px 2353.93359375px',
								'278.02734375px 2357.87109375px',
								'278.02734375px 2361.4921875px',
								'278.02734375px 2361.4921875px',
								'277.39453125px 2376.3046875px',
								'277.3125px 2380.8515625px',
								'276.9375px 2385.1875px',
								'276.9375px 2388.4921875px',
								'276.78515625px 2393.94140625px',
								'276.4921875px 2400px',
								'276.4921875px 2409.7265625px',
								'276.4921875px 2421.05859375px',
								'276.4921875px 2432.9765625px',
								'276.4921875px 2432.9765625px',
								'276.9140625px 2444.0859375px',
								'276.9609375px 2455.86328125px',
								'276.9609375px 2464.171875px',
								'276.9609375px 2476.86328125px',
								'276.9609375px 2484.46875px',
								'276.9609375px 2490.83203125px',
								'276.9609375px 2490.83203125px',
								'276.31640625px 2510.90625px',
								'276.17578125px 2517.1875px',
								'276.17578125px 2520.6328125px',
								'276.17578125px 2525.23828125px',
								'276.17578125px 2528.0390625px',
								'276.17578125px 2532.24609375px',
								'276.17578125px 2536.734375px',
								'276.17578125px 2540.5546875px',
								'275.96484375px 2543.96484375px',
								'275.859375px 2548.4765625px',
								'275.859375px 2551.6875px',
								'275.859375px 2553.50390625px',
								'275.859375px 2555.75390625px',
								'275.859375px 2557.67578125px',
								'275.859375px 2560.08984375px',
								'275.859375px 2560.08984375px',
								'275.859375px 2565.9375px',
								'275.859375px 2570.44921875px',
								'276.1171875px 2574.5625px',
								'276.17578125px 2580.6328125px',
								'276.17578125px 2587.9921875px',
								'276.17578125px 2591.015625px',
								'276.22265625px 2596.6171875px',
								'276.55078125px 2600.23828125px',
								'277.0078125px 2605.93359375px',
								'277.4296875px 2611.1015625px',
								'277.6171875px 2615.953125px',
								'277.88671875px 2620.078125px',
								'278.34375px 2626.265625px',
								'278.34375px 2626.265625px',
								'278.94140625px 2632.359375px',
								'278.94140625px 2635.86328125px',
								'279px 2640.5390625px',
								'279.19921875px 2643.1875px',
								'279.19921875px 2645.71875px',
								'279.328125px 2647.8515625px',
								'279.421875px 2650.06640625px',
								'279.421875px 2652.29296875px',
								'279.421875px 2654.671875px',
								'279.48046875px 2658.12890625px',
								'279.984375px 2664.3984375px',
								'280.30078125px 2670.2578125px',
								'280.453125px 2676.41015625px',
								'281.35546875px 2685.890625px',
								'281.35546875px 2685.890625px',
								'282.92578125px 2716.640625px',
								'283.453125px 2727.99609375px',
								'283.48828125px 2730.4453125px',
								'283.48828125px 2732.7890625px',
								'283.48828125px 2735.015625px',
								'283.48828125px 2738.203125px',
								'283.48828125px 2739.9609375px',
								'283.6640625px 2742.09375px',
								'283.79296875px 2744.1328125px',
								'283.79296875px 2746.04296875px',
								'283.79296875px 2748.1640625px',
								'284.21484375px 2752.81640625px',
								'284.21484375px 2754.5625px',
								'284.21484375px 2757.09375px',
								'284.21484375px 2758.86328125px',
								'284.21484375px 2759.82421875px',
								'284.21484375px 2759.82421875px',
								'284.21484375px 2760.9140625px',
								'284.21484375px 2762.0390625px',
								'284.21484375px 2763.50390625px',
								'284.21484375px 2764.79296875px',
								'284.21484375px 2767.23046875px',
								'284.21484375px 2769.24609375px',
								'284.21484375px 2770.5703125px',
								'284.21484375px 2772.3046875px',
								'284.21484375px 2774.3671875px',
								'284.21484375px 2776.79296875px',
								'284.21484375px 2778.8203125px',
								'284.21484375px 2780.73046875px',
								'284.484375px 2782.69921875px',
								'284.49609375px 2784.57421875px',
								'284.49609375px 2784.7265625px',
								'284.49609375px 2789.40234375px',
								'284.49609375px 2792.56640625px',
								'284.49609375px 2794.3359375px',
								'284.49609375px 2796.19921875px',
								'284.70703125px 2798.4609375px',
								'284.80078125px 2801.2734375px',
								'284.9765625px 2802.69140625px',
								'285.41015625px 2806.59375px',
								'285.7265625px 2809.30078125px',
								'286.06640625px 2813.671875px',
								'286.359375px 2817.94921875px',
								'287.16796875px 2822.296875px',
								'288.890625px 2827.59375px',
								'292.171875px 2835.0703125px',
								'294.375px 2839.4296875px',
								'295.921875px 2842.9453125px',
								'296.80078125px 2845.27734375px',
								'299.35546875px 2851.1953125px',
								'300.46875px 2856px',
								'301.4296875px 2861.015625px',
								'302.90625px 2865.85546875px',
								'303.85546875px 2869.921875px',
								'304.4765625px 2871.62109375px',
								'305.390625px 2873.5546875px',
								'306.08203125px 2875.40625px',
								'306.76171875px 2877.5390625px',
								'306.76171875px 2879.484375px',
								'306.83203125px 2881.41796875px',
								'307.04296875px 2883.19921875px',
								'307.13671875px 2884.3359375px',
								'307.2421875px 2884.65234375px',
								'307.2421875px 2884.8515625px',
								'307.2421875px 2884.93359375px',
								'307.2421875px 2884.93359375px',
								'307.01953125px 2884.06640625px',
								'304.48828125px 2880.85546875px',
								'293.21484375px 2870.77734375px',
								'265.0546875px 2850.28125px',
								'265.0546875px 2850.28125px',
								'231.83203125px 2825.6484375px',
								'78.36328125px 2715.4921875px',
							],
							{
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
							},
						),
					}}
				/>
			</AbsoluteFill>
		</HtmlInCanvas>
	);
};

export const CloseUp8 = () => {
	return (
		<Composition
			id="HoverOverOutlines"
			component={CloseUp8Preview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={612}
		/>
	);
};
